import React from 'react'
import PropTypes from 'prop-types'
import {Table} from 'reactstrap'
import ListItemsItem from './ListItemsItem'
import {canViewStoreName} from '../../services/StorageServices'
import BulkGenLabel from './BulkActions/BulkGenLabel'
import BulkChangeStatus from './BulkActions/BulkChangeStatus'
import Button from 'reactstrap/es/Button'
import DeleteSelectItem from './BulkActions/DeleteSelectItem'

class ListItemsTable extends React.Component {
    state = {
        allSelected: false,
        isChecked: false,
        selectedItems: [],
        isOpen: false,
    }

    _parseProductsItems = (items) => {
        const results = []

        for (let item of items) {
            const {labelDetails: orderLabelDetails, ...itemWithoutProducts} = item
            let products = item.products

            if (item.hasOwnProperty('filteredProducts')) {
                products = item.filteredProducts
            }

            const product_labels = products.filter(product => {
                return product.hasOwnProperty('labelDetails')
            })
            if (orderLabelDetails) {
                Object.assign(itemWithoutProducts, {'orderLabelDetails': orderLabelDetails})
            }
            const multiLabel = product_labels.length > 0
            Object.assign(itemWithoutProducts, {'multiLabel': multiLabel})
            if (!Array.isArray(products) || products.length === 0) {
                continue
            }

            const firstProduct = products[0]
            const listProducts = products.slice(1)

            const {_id: productId, status, isShipped, ...restFirstProduct} = firstProduct
            if (multiLabel === true) {
                Object.assign(restFirstProduct, {'isShipped': isShipped})
            }

            Object.assign(restFirstProduct, {'hasLabel': restFirstProduct.hasOwnProperty('labelDetails')})
            results.push(Object.assign({}, itemWithoutProducts, {
                ...restFirstProduct,
                productId,
                productStatus: status,
                isSubitem: false,
            }))
            for (let itemProduct of listProducts) {
                const {_id: _productId, status: _status, isShipped: _isShipped, ...restItemProduct} = itemProduct
                Object.assign(restItemProduct, {'hasLabel': restItemProduct.hasOwnProperty('labelDetails')})
                if (multiLabel === true) {
                    Object.assign(restItemProduct, {'isShipped': _isShipped})
                }
                results.push({
                    ...itemWithoutProducts,
                    ...restItemProduct,
                    productId: _productId,
                    productStatus: _status,
                    isSubitem: true,
                })
            }
        }

        return results
    }

    _toggleSelectAll = (e) => {
        const {checked} = e.target

        this.setState(() => {
            if (checked) {
                const {items} = this.props
                const itemsCanChecked = items.filter(item => (item.products.length > 0 && item.production_status !== 'labelled' && item.production_status !== 'packaged'))

                return {
                    allSelected: true,
                    isChecked: true,
                    selectedItems: itemsCanChecked.map(order => order._id),
                }
            }

            return {
                allSelected: false,
                isChecked: false,
                selectedItems: [],
            }
        })
    }

    _handleChangeSelected = (id, isAdded) => {
        const {selectedItems} = this.state
        const {items} = this.props
        const itemsCanChecked = items.filter(item => (item.production_status !== 'labelled' && item.production_status !== 'packaged'))

        if (isAdded) {
            if (!selectedItems.includes(id)) {
                this.setState({
                    selectedItems: [...selectedItems, id],
                    allSelected: selectedItems.length + 1 === itemsCanChecked.length,
                })
            }
        } else {
            const filtered = selectedItems.filter(orderId => orderId !== id)

            this.setState({
                selectedItems: filtered,
                allSelected: false,
            })
        }
    }

    _resetBulkAll = () => {
        this.setState({
            allSelected: false,
            isChecked: false,
            selectedItems: [],
            isOpen: false,
        })
    }

    _isOpen = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        })
    }

    render() {
        const {allSelected, selectedItems, isOpen} = this.state
        const {items, reloadItems, ...rest} = this.props
        const parsedItems = this._parseProductsItems(items)
        const canViewStore = canViewStoreName()

        return (
            <div className='ListItemsTable'>
                <Table responsive>
                    <thead>
                    {selectedItems.length > 0 ? (
                        <tr>
                            <th>
                                <input type='checkbox' className='inputCheckboxSelectedAll' id='OrderColAllSelection'
                                       checked={allSelected}
                                       onChange={this._toggleSelectAll}
                                />
                            </th>
                            <th>
                                <div className="CustomSelect">
                                    <Button onClick={this._isOpen}
                                            className="dropdown-toggle">Actions</Button>
                                    <div className={isOpen ? 'ListAction open' : 'ListAction'}>
                                        <BulkGenLabel
                                            selectedItems={selectedItems}
                                            items={items}
                                            resetBulkAll={this._resetBulkAll}
                                            reloadItems={reloadItems}
                                        />
                                        <BulkChangeStatus
                                            selectedItems={selectedItems}
                                            items={items}
                                            resetBulkAll={this._resetBulkAll}
                                            reloadItems={reloadItems}
                                        />
                                        <DeleteSelectItem
                                            selectedItems={selectedItems}
                                            items={items}
                                            resetBulkAll={this._resetBulkAll}
                                            reloadItems={reloadItems}
                                        />
                                    </div>
                                    {
                                        isOpen && <div className="Background" onClick={this._isOpen}/>
                                    }
                                </div>
                            </th>
                            <th colSpan={11}>
                                <strong>{selectedItems.length} {selectedItems.length !== 1 ? 'items' : 'item'} selected</strong>
                            </th>
                        </tr>
                    ) : (
                        <tr>
                            <th>
                                <input type='checkbox' className='inputCheckboxSelectedAll' id='OrderColAllSelection'
                                       checked={allSelected}
                                       onChange={this._toggleSelectAll}
                                />
                            </th>
                            <th className="OrderNumber"># Order Number</th>
                            <th>
                                <div className="text-muted font-size-sm">
                                    <span className="badge badge-mark border-success mr-1"/>
                                    Printed At
                                </div>
                                <div className="text-muted font-size-sm">
                                    <span className="badge badge-mark border-danger mr-1"/>
                                    Printed IP
                                </div>
                            </th>
                            <th>Mock Up Front</th>
                            <th>Mock Up Back</th>
                            <th>Design Front</th>
                            <th>Design Back</th>
                            <th>Variants</th>
                            <th>Address</th>
                            <th>
                                Label
                                <div className="text-muted font-size-sm">
                                    <span className="badge badge-mark border-success mr-1"/>
                                    Shipped At
                                </div>
                                <div className="text-muted font-size-sm">
                                    <span className="badge badge-mark border-danger mr-1"/>
                                    Shipped IP
                                </div>
                            </th>
                            <th>Created</th>
                            <th>Production time / Commitment time</th>
                            <th className="Action">Actions</th>
                        </tr>
                    )}
                    </thead>
                    <tbody>
                    {
                        parsedItems.length > 0 ? parsedItems.map((item, i) => {
                                return <ListItemsItem
                                    {...rest}
                                    key={i}
                                    index={i}
                                    item={item}
                                    canViewStore={canViewStore}
                                    reloadItems={reloadItems}
                                    selectedItems={selectedItems}
                                    onChangeSelected={this._handleChangeSelected}
                                />
                            })
                            : <tr>
                                <td colSpan={13}>Không có dữ liệu</td>
                            </tr>
                    }
                    </tbody>
                </Table>
            </div>
        )
    }
}

ListItemsTable.propTypes = {
    items: PropTypes.array.isRequired,
}

export default ListItemsTable
